export default {
    createNewDepartment: 'Create New Department',
    departmentName: 'Department Name',
    description: 'Description',
    managerInformation: 'Manager Information',
    fullName: 'Full Name',
    eamilAddress: 'Eamil Address',
    phoneNumber: 'Phone Number',
    firstPermissionLevel: 'First Permission Level',
    secondPermissionLevel: 'Second Permission Level',
    thisFieldIsRequired: 'This field is required',
    incorrectPhoneNubmer: 'Incorrect phone nubmer',
    thisFieldIsExceededCharacters: 'This field is exceeded 255 characters',
    save: 'Save',
    emailIsRequired: 'E-mail is required',
    invalidEmailFormat: 'Invalid e-mail format',
    emailIsExceededCharacters: 'E-mail is exceeded 255 characters',
    congratulation: 'Congratulation',
    errorMessage: 'Error Message',
    editDepartment: 'Edit Department',
    departmentIsCreated: 'Department is created',
    departmentIsUpdated: 'Department is updated'
}
